import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { t } from 'i18next'
import { colors } from '../../../styles/colors'
import InformationPopover from '../../InformationPopover/InformationPopover'
import MediaQuery from 'react-responsive'

const StyledSerialKey = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const SerialkeyView = ({id, serialkey, disabled = false, handleOnChange, handleOnBlur, handleOnKeyDown, formError}) => {

  return (
    <div className="mb-3">  
      <Form.Group className="mb-3">
      <Form.Label >{t('createLocalInventory:serialkey')}</Form.Label><MediaQuery minWidth={550}><InformationPopover header={t('createLocalInventory:serialkey')} content={t('createLocalInventory:serialkeyInfo')} /></MediaQuery>
        {!disabled
          ?
          <>
          <Form.Control
            id={id}
            name="serialkey"
            placeholder={t('createLocalInventory:serialkey')}
            value={serialkey}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            onKeyDown={handleOnKeyDown}
            isInvalid={!!formError}
          />
          <Form.Control.Feedback type="invalid">
          {formError}
          </Form.Control.Feedback>
          </> 
          : <StyledSerialKey>{`${t('createLocalInventory:serialkey')}: ${serialkey}`}</StyledSerialKey>
        }
      </Form.Group>
    </div>

  )
}
export default SerialkeyView